import React, { FunctionComponent } from 'react';

export interface BreadcrumbItem {
  url?: string;
  title: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
	homeIcon: JSX.Element;
	separatorIcon: JSX.Element;
	baseLangUrl: string;
}

const Breadcrumb: FunctionComponent<BreadcrumbProps> = ({items, homeIcon, separatorIcon, baseLangUrl}) => {

	function displayItem(item: BreadcrumbItem, key: number): JSX.Element {
		let jsx: JSX.Element = (
			<span style={{margin: '5px 0'}} key={key}>
				{separatorIcon}
				{item.title}
			</span>
		);
		if (item.url) {
			jsx = (
				<a href={item.url} className="cursor-pointer d-flex align-items-center d-md-block" key={key}>
					{separatorIcon}
					{item.title}
				</a>
			);
		}
		return jsx;
	}

  return (
		<div className="m-0 dark-grey arianne mb-5 mt-0 pt-0 pt-lg-0 row">
			<h5 className="font15 d-flex align-items-center m-0 ">
				<a href={`/${baseLangUrl.replace(/\/$/, '')}/`} className="cursor-pointer d-flex align-items-center d-md-block">
					{homeIcon}
				</a>
				{items.map((item, i) => displayItem(item, i))}
			</h5>
		</div>
  );
};

export default Breadcrumb;
